import React from 'react';
import { CheckIcon } from 'lucide-react';
export function WhatYouLearnSection() {
  return <section className="py-20 bg-brand-dark" data-id="element-277">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-278">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-279">
          <div className="lg:w-1/3" data-id="element-280">
            <img src="https://i.postimg.cc/rwN6HSy0/Portada-ebook-principal-terminada.webp" alt="Ebook Protocolo Maestro" className="w-full rounded-lg shadow-[0_0_40px_rgba(212,175,55,0.15)] transform hover:rotate-2 transition duration-500 border border-white/5" data-id="element-281" />
          </div>

          <div className="lg:w-2/3" data-id="element-282">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-283">
              La Anatomía de tu Rescate Capilar
            </h2>
            <p className="text-gray-400 font-light mb-8" data-id="element-284">
              Dentro de las páginas del <strong data-id="element-285">Protocolo Maestro</strong>,
              descubrirás exactamente:
            </p>

            <div className="grid md:grid-cols-2 gap-x-6 gap-y-4" data-id="element-286">
              <div className="flex items-start" data-id="element-287">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-288" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-289">
                  La <strong data-id="element-290">receta milimétrica</strong> del tónico de jengibre
                  de alta concentración.
                </span>
              </div>
              <div className="flex items-start" data-id="element-291">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-292" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-293">
                  El error fatal al lavar tu cabello que está{' '}
                  <strong data-id="element-294">arrancando tus folículos</strong> sanos.
                </span>
              </div>
              <div className="flex items-start" data-id="element-295">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-296" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-297">
                  Cómo <strong data-id="element-298">bloquear la hormona DHT</strong> (la asesina
                  capilar) usando ingredientes de tu despensa.
                </span>
              </div>
              <div className="flex items-start" data-id="element-299">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-300" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-301">
                  El <strong data-id="element-302">Mapeo Térmico:</strong> Las 4 zonas del cuero
                  cabelludo y cómo masajearlas.
                </span>
              </div>
              <div className="flex items-start" data-id="element-303">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-304" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-305">
                  El cronograma exacto de <strong data-id="element-306">14 días</strong>: qué hacer,
                  cuándo y cómo.
                </span>
              </div>
              <div className="flex items-start" data-id="element-307">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-308" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-309">
                  Por qué el agua caliente es tu peor enemigo y el{' '}
                  <strong data-id="element-310">choque térmico</strong> tu mejor amigo.
                </span>
              </div>
              <div className="flex items-start" data-id="element-311">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-312" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-313">
                  Cómo <strong data-id="element-314">almacenar el tónico</strong> para no matar el
                  Gingerol Activo.
                </span>
              </div>
              <div className="flex items-start" data-id="element-315">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-316" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-317">
                  El test de porosidad capilar en casa (solo necesitas un vaso
                  de agua).
                </span>
              </div>
              <div className="flex items-start" data-id="element-318">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-319" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-320">
                  Alimentos "inofensivos" que en realidad provocan inflamación
                  en tu raíz.
                </span>
              </div>
              <div className="flex items-start" data-id="element-321">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-322" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-323">
                  Qué hacer si tienes cuero cabelludo muy graso o extremadamente
                  seco.
                </span>
              </div>
              <div className="flex items-start" data-id="element-324">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-325" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-326">
                  El secreto para reactivar folículos que llevan meses
                  "dormidos".
                </span>
              </div>
              <div className="flex items-start" data-id="element-327">
                <CheckIcon className="w-4 h-4 text-brand-gold mt-1 mr-3 flex-shrink-0" data-id="element-328" />
                <span className="text-gray-300 text-sm leading-relaxed" data-id="element-329">
                  Cómo mantener los resultados de por vida sin ser esclava del
                  tratamiento.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}